import React from "react";
import { useContent } from "@/lib/content";
import CountUp from "@/components/CountUp";

const FALLBACK = [
  { num: "500", suffix: "+", label: "Students Guided" },
  { num: "50", suffix: "+", label: "Top Rank Holders" },
  { num: "100", suffix: "%", label: "Support Till You Pass" },
  { num: "20", suffix: "+", label: "Hiring Partners" },
];

export default function Stats() {
  const { content } = useContent();
  const stats = content.stats?.length ? content.stats : FALLBACK;

  return (
    <section id="stats" data-testid="stats-section" className="bg-[#002570] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.07] bg-[radial-gradient(ellipse_at_top_left,_white,_transparent_60%)]" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {stats.map((s, i) => (
            <div key={i} data-testid={`stat-${i}`} className="text-center md:text-left">
              <div className="font-rubik text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#73c3ff] tracking-tight">
                <CountUp value={s.num} suffix={s.suffix || ""} />
              </div>
              <div className="mt-2 font-inter text-sm md:text-base text-white/80 font-medium">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
